import { GetPlaceFromCoordinatesRequest } from '@eventbrite/geo-service-pysoa-model';

import { ecsGetPlaceFromCoordinates } from '@/src/homepage/api/geo/geoServiceHttpClient';

/**
 * Get the place from coordinates via geo-service-http (ECS/Fargate).
 */
export async function getPlaceFromCoordinates(
    latitude: string | number,
    longitude: string | number,
    placeType?: GetPlaceFromCoordinatesRequest['body']['place_type'],
) {
    try {
        const response = await ecsGetPlaceFromCoordinates({
            latitude: Number(latitude),
            longitude: Number(longitude),
            placeType,
        });
        return response?.['place'] || null;
    } catch (error) {
        // Log the actual failure detail (message/stack, plus HTTP status + response body when
        // geoServiceHttpClient's fetchJson attached them) rather than the bare Error object --
        // console.error on a raw Error often prints as an opaque `[Error]` with no message in
        // some log pipelines, which has repeatedly made "why did this return null" undebuggable
        // (DNS failure, timeout, non-2xx, and malformed JSON all looked identical).
        console.error('Failed to fetch place from coordinates from geo-service-http', {
            latitude,
            longitude,
            message: error instanceof Error ? error.message : String(error),
            status: error instanceof Error ? (error as { status?: number }).status : undefined,
            body: error instanceof Error ? (error as { body?: string }).body : undefined,
            cause: error instanceof Error ? (error as { cause?: unknown }).cause : undefined,
            stack: error instanceof Error ? error.stack : undefined,
        });
        return null;
    }
}
